import { DatePipe } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MultiSelectModule } from 'primeng/multiselect';
import { ToastModule } from 'primeng/toast';
import { MessagesModule } from 'primeng/messages';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { PasswordModule } from 'primeng/password';
import { PaginatorModule } from 'primeng/paginator';
import { InputTextModule } from 'primeng/inputtext';
import { TreeModule } from 'primeng/tree';
import { TooltipModule } from 'primeng/tooltip';
import { TableModule } from 'primeng/table';
import { ToolbarModule } from 'primeng/toolbar';
import { CardModule } from 'primeng/card';
import { MenuModule } from 'primeng/menu';
import { AvatarModule } from 'primeng/avatar';
import { TabViewModule } from 'primeng/tabview';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { ListboxModule } from 'primeng/listbox';
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { PanelMenuModule } from 'primeng/panelmenu';
import { SidebarModule } from 'primeng/sidebar';
import { PanelModule } from 'primeng/panel';
import { NgxShimmerLoadingModule } from 'ngx-shimmer-loading';
import { ImageCropperModule } from 'ngx-image-cropper';
import { InputMaskModule } from 'primeng/inputmask';
import { QuillModule } from 'ngx-quill';
import { ChipModule } from 'primeng/chip';
import { CheckboxModule } from 'primeng/checkbox';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ChartModule } from 'primeng/chart';
import { CalendarModule } from 'primeng/calendar';
import { ProgressBarModule } from 'primeng/progressbar';
import { NgOtpInputModule } from 'ng-otp-input';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { DropdownModule } from 'primeng/dropdown';

//Project's page Module
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { LoginComponent } from './login/login.component';
import { TwoFactorApproveComponent } from './two-factor-approve/two-factor-approve.component';
import { SignupComponent } from './signup/signup.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ProfileComponent } from './profile/profile.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { UserComponent } from './user/user.component';
import { ClientcommunicationComponent } from './clientcommunication/clientcommunication.component';
import { BroadcastMessageComponent } from './clientcommunication/broadcast-message/broadcast-message.component';
import { ClientDatamanagementComponent } from './client-datamanagement/client-datamanagement.component';
import { LogoutComponent } from './logout/logout.component';
import { RoleComponent } from './role/role.component';
import { AuthGuard } from './services/authguard/auth.guard';
import { environment } from 'src/environments/environment';
import { ChatAreaComponent } from './clientcommunication/chat-area/chat-area.component';
import { ChatSidebarComponent } from './clientcommunication/chat-sidebar/chat-sidebar.component';
import { ChatDefaultPageComponent } from './clientcommunication/chat-area/chat-default-page/chat-default-page.component';
import { ChatRoomComponent } from './clientcommunication/chat-area/chat-room/chat-room.component';
import { FilterPipe } from './pipe/filter.pipe';
import { FrequentlyAskedQuestionsComponent } from './frequently-asked-questions/frequently-asked-questions.component';
import { ConfirmationService, MessageService } from 'primeng/api';
import { SupportTicketsComponent } from './support-tickets/support-tickets.component';
import { ImageCropperDialogComponent } from './custom/image-cropper-dialog/image-cropper-dialog.component';
import { HowToComponent } from './how-to/how-to.component';
import { ReportsComponent } from './reports/reports.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { ManageDiscountComponent } from './manage-discount/manage-discount.component';
import { ManageSubscriptionPlanComponent } from './manage-subscription-plan/manage-subscription-plan.component';
import { ManageHolidaysComponent } from './manage-holidays/manage-holidays.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    LoginComponent,
    TwoFactorApproveComponent,
    SignupComponent,
    DashboardComponent,
    ProfileComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    UserComponent,
    ClientcommunicationComponent,
    BroadcastMessageComponent,
    ClientDatamanagementComponent,
    LogoutComponent,
    RoleComponent,
    ChatAreaComponent,
    ChatSidebarComponent,
    ChatDefaultPageComponent,
    ChatRoomComponent,
    FilterPipe,
    FrequentlyAskedQuestionsComponent,
    SupportTicketsComponent,
    HowToComponent,
    ImageCropperDialogComponent,
    ReportsComponent,
    TermsAndConditionsComponent,
    PrivacyPolicyComponent,
    ManageDiscountComponent,
    ManageSubscriptionPlanComponent,
    ManageHolidaysComponent
  ],

  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ProgressSpinnerModule,
    MultiSelectModule,
    ToastModule,
    MessagesModule,
    ConfirmDialogModule,
    DialogModule,
    ButtonModule,
    PasswordModule,
    PaginatorModule,
    InputTextModule,
    TreeModule,
    TooltipModule,
    TableModule,
    ToolbarModule,
    CardModule,
    MenuModule,
    AvatarModule,
    TabViewModule,
    BreadcrumbModule,
    InputTextareaModule,
    ScrollPanelModule,
    ListboxModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFirestoreModule, // for firestore
    AngularFireStorageModule,
    PanelMenuModule,
    SidebarModule,
    PanelModule,
    QuillModule.forRoot(),
    NgxShimmerLoadingModule,
    ImageCropperModule,
    InputMaskModule,
    ChipModule,
    CheckboxModule,
    InputSwitchModule,
    ChartModule,
    CalendarModule,
    ProgressBarModule,
    NgOtpInputModule,
    OverlayPanelModule,
    DropdownModule
  ],
  providers: [AuthGuard, MessageService, ConfirmationService, DatePipe],
  bootstrap: [AppComponent],
})
export class AppModule { }
